import "./App.css";
import React, { useState } from "react";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Materials from "./pages/Materials";
import OverallMaterials from "./pages/OverallMaterials";
import CurrentAffairs from "./pages/CurrentAffairs";
import CurrentAffairsDetail from "./pages/CurrentAffairsDetail";
import MaterialsSubject from "./pages/MaterialsSubject";
import MaterialsTopic from "./pages/MaterialsTopic";
import MaterialsSubTopicContent from "./pages/MaterialsSubTopicContent";
import MaterialsFolder from "./pages/MaterialsFolder";
import QuestionBank from "./pages/QuestionBank";
import QuestionBankSubject from "./pages/QuestionBankSubject";
import QuestionBankTopic from "./pages/QuestionBankTopic";
import QuestionBankSubtopicContent from "./pages/QuestionBankSubtopicContent";
import QuestionBankFolder from "./pages/QuestionBankFolder";
import QuestionBankFolderTestPage from "./pages/QuestionBankFolderTestPage";
import Subject from "./pages/subject";
import Topic from "./pages/topic";
import SubTopic from "./pages/subTopic";
import SubTopicContent from "./pages/subTopicContent";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import TestPage from "./pages/TestPage";
import SurveyPage from "./pages/SurveyPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { useSelector } from "react-redux";
import GlobalLoader from "./components/GlobalLoader";
import { DrawerProvider, useDrawer } from "./contexts/DrawerContext";
import Drawer from "./components/Drawer";
import AiTutor from "./components/AiTutor";
import ActiveRecall from "./pages/ActiveRecall";
import AdaptiveLearning from "./pages/AdaptiveLearning";
import AdaptiveLearningContent from "./pages/AdaptiveLearningContent";
import AdaptiveShowContent from "./pages/AdaptiveShowContent";
import Homeworks from "./pages/Homeworks";
import HomeworkReviewPage from "./pages/HomeworkReviewPage";
import OverallTest from "./pages/OverallTest";
import Videos from "./pages/Videos";
import CoursesRedirect from "./pages/CoursesRedirect";
import ErrorBoundary from "./components/ErrorBoundary";

const AppContent = () => {
  const [collapsed, setCollapsed] = useState(false);
  const loading = useSelector((state) => state.breadcrumbs.loading);
  const location = useLocation();
  const { drawerState, closeDrawer } = useDrawer();
  const isFullScreenPage =
    location.pathname === "/login" ||
    location.pathname === "/reset-password" ||
    location.pathname.startsWith("/test") ||
    location.pathname.startsWith("/survey") ||
    location.pathname.startsWith("/homework-review");

  return (
    <div
      className={`App ${collapsed ? "app-collapsed" : ""} ${
        isFullScreenPage ? "login-mode" : ""
      }`}
    >
      {loading && <GlobalLoader />}
      {!isFullScreenPage && <Header />}
      {!isFullScreenPage && (
        <Navbar
          collapsed={collapsed}
          onToggleCollapse={() => setCollapsed((c) => !c)}
        />
      )}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/survey"
          element={
            <ProtectedRoute>
              <SurveyPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/test"
          element={
            <ProtectedRoute>
              <TestPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/test/:pageid"
          element={
            <ProtectedRoute>
              <TestPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/materials/:coursekey"
          element={
            <ProtectedRoute>
              <Materials />
            </ProtectedRoute>
          }
        />
        <Route
          path="/overall-materials/:coursekey"
          element={
            <ProtectedRoute>
              <OverallMaterials />
            </ProtectedRoute>
          }
        />
        <Route
          path="/current-affairs"
          element={
            <ProtectedRoute>
              <CurrentAffairs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/current-affairs/:coursekey"
          element={
            <ProtectedRoute>
              <CurrentAffairs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/current-affairs/blog/:blogId"
          element={
            <ProtectedRoute>
              <CurrentAffairsDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/overall-test/:coursekey"
          element={
            <ProtectedRoute>
              <OverallTest />
            </ProtectedRoute>
          }
        />
        <Route
          path="/materials/:coursekey/:subjectkey"
          element={
            <ProtectedRoute>
              <MaterialsSubject />
            </ProtectedRoute>
          }
        />
        <Route
          path="/materials/:coursekey/:subjectkey/:topickey"
          element={
            <ProtectedRoute>
              <MaterialsTopic />
            </ProtectedRoute>
          }
        />
        <Route
          path="/materials/:coursekey/:subjectkey/:topickey/:subtopickey"
          element={
            <ProtectedRoute>
              <MaterialsSubTopicContent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/materials-folder/:folderid"
          element={
            <ProtectedRoute>
              <MaterialsFolder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/question-bank/:coursekey"
          element={
            <ProtectedRoute>
              <QuestionBank />
            </ProtectedRoute>
          }
        />
        <Route
          path="/question-bank/:coursekey/:subjectkey"
          element={
            <ProtectedRoute>
              <QuestionBankSubject />
            </ProtectedRoute>
          }
        />
        <Route
          path="/question-bank/:coursekey/:subjectkey/:topickey"
          element={
            <ProtectedRoute>
              <QuestionBankTopic />
            </ProtectedRoute>
          }
        />
        <Route
          path="/question-bank/:coursekey/:subjectkey/:topickey/:subtopickey"
          element={
            <ProtectedRoute>
              <QuestionBankSubtopicContent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/question-bank-folder/:folderid"
          element={
            <ProtectedRoute>
              <QuestionBankFolder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/question-bank-folder/:folderid/:testid"
          element={
            <ProtectedRoute>
              <QuestionBankFolderTestPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />

        <Route
          path="/aitutor"
          element={
            <ProtectedRoute>
              <AiTutor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses"
          element={
            <ProtectedRoute>
              <CoursesRedirect />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/:coursekey"
          element={
            <ProtectedRoute>
              <Subject />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/:coursekey/:subjectkey"
          element={
            <ProtectedRoute>
              <Topic />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/:coursekey/:subjectkey/:topickey"
          element={
            <ProtectedRoute>
              <SubTopic />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/:coursekey/:subjectkey/:topickey/:subtopickey"
          element={
            <ProtectedRoute>
              <SubTopicContent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/adaptive-learning"
          element={
            <ProtectedRoute>
              <AdaptiveLearning />
            </ProtectedRoute>
          }
        />
        <Route
          path="/adaptive-learning/:topicId"
          element={
            <ProtectedRoute>
              <AdaptiveLearningContent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/adaptive-learning/:id/:mode"
          element={<AdaptiveShowContent />}
        />

        <Route
          path="/active-recall"
          element={
            <ProtectedRoute>
              <ActiveRecall />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/gamification"
          element={
            <ProtectedRoute>
              <GamificationHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gamification/:gameType"
          element={
            <ProtectedRoute>
              <GameListPage />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/homeworks"
          element={
            <ProtectedRoute>
              <Homeworks />
            </ProtectedRoute>
          }
        />
        <Route
          path="/homework-review"
          element={
            <ProtectedRoute>
              <HomeworkReviewPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/videos"
          element={
            <ProtectedRoute>
              <Videos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/videos/:coursekey"
          element={
            <ProtectedRoute>
              <Videos />
            </ProtectedRoute>
          }
        />
      </Routes>

      <Drawer
        isOpen={drawerState.isOpen}
        onClose={closeDrawer}
        title={drawerState.title}
        subtitle={drawerState.subtitle}
        items={drawerState.items}
        onItemClick={drawerState.onItemClick || (() => {})}
        courseName={drawerState.courseName}
        subjectName={drawerState.subjectName}
        selectedId={drawerState.selectedId}
      />
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <DrawerProvider>
          <AppContent />
        </DrawerProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default App;
